const PanDelay: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="38"
      height="38"
      fill="none"
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <g clipPath="url(#clip0_3876_26157)">
        <path
          d="M12.6652 3.91602V11.8327H15.8319V3.91602H12.6652ZM6.33187 5.49935V11.8327H9.49854V5.49935H6.33187ZM18.9985 5.49935V11.8327H22.1652V5.49935H18.9985ZM29.3273 10.2493C27.8282 10.2525 26.5517 11.3171 26.238 12.7573L25.7524 14.9993H0.0078125L1.71484 23.5376C2.0099 25.0066 3.32088 26.0827 4.81966 26.0827H24.033C25.5318 26.0827 26.8428 25.0066 27.1379 23.5376L27.1348 23.5623L29.3335 13.4315C29.3363 13.4182 29.3443 13.416 29.3335 13.416H37.9985V10.2493H29.3304H29.3273ZM3.87028 18.166H25.0628L24.0361 22.9036L24.033 22.916H4.81966L3.87028 18.166Z"
          fill="currentColor"
        />
        <rect x="15" y="14" width="24" height="24" rx="12" fill="#F6F6F6" />
        <path
          d="M27 16C22.238 16 18.2451 19.3543 17.2461 23.8203L17.2441 23.8184C17.2411 23.8304 17.2413 23.8435 17.2383 23.8555C17.1663 24.1825 17.1093 24.5136 17.0703 24.8516C17.0683 24.8726 17.0645 24.8921 17.0625 24.9121C17.0235 25.2691 17 25.632 17 26H17.0039V26.0078L19.5 26C19.499 25.411 19.5663 24.8946 19.6953 24.3246C20.3125 20.5 24 18.5 27 18.5C31.5 18.5 34.5 22 34.5 26.0078C34.5 30.0156 31.5 33 28 33.5C27.419 33.561 26.582 33.567 26 33.5L25.8457 35.9355C26.2287 35.9795 26.613 35.999 26.998 35.998V36C27.344 36 27.6864 35.9813 28.0234 35.9473C28.0314 35.9463 28.0389 35.9483 28.0469 35.9473V35.9453C33.0689 35.4193 37 31.158 37 26C37 20.489 32.511 16 27 16ZM26 20V27.7773H31V25H28V20H26ZM19.5 27.5L18.1816 27.7773L17.2207 28.0645C17.3667 28.7555 17.5832 29.4284 17.8672 30.0684L20 29C19.773 28.487 19.63 28.115 19.5 27.5ZM21 30.5L18.8496 31.793C19.2736 32.389 19.7655 32.9396 20.3125 33.4316L21.9996 31.793C21.5626 31.4 21.339 30.977 21 30.5ZM23 32.5L21.9062 34.6035C22.5373 34.9775 23.2122 35.2837 23.9102 35.5117L24.5 33.5C23.941 33.317 23.504 32.8 23 32.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3876_26157">
          <rect width="38" height="38" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PanDelay;
